export default __webpack_public_path__ + "static/media/935.6e537caa.gif";